import { breakpointSiteheader, getBreakpoint } from '@shared/Frontend/utils/breakpoints'
import * as React from 'react'
import { SiteheaderLayout } from '../../../../../EntryPoint/Frontend/root/siteheader/siteheader.layout'
import { StyleguideExample, StyleguidePart } from '../../../../../Shared/Hoppinger.Styleguide/Frontend'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentsSiteheader = () => (
  <>
    <StyleguidePart title="Default" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={true}>
        <ComponentSiteheader />
      </StyleguideExample>
    </StyleguidePart>
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentSiteheader = ({ isProductActive }: { isProductActive?: boolean }) => {
  const [mode, setMode] = React.useState<'closed' | 'open'>('closed')
  const breakpoint = getBreakpoint()
  return (
    <SiteheaderLayout
      language="nl"
      node="none"
      isMenuOpen={mode == 'open'}
      toggleMenu={() => setMode((s) => (s == 'open' ? 'closed' : 'open'))}
      items={[
        {
          title: 'Expertise',
          url: '#',
          isExternal: false,
          isActive: false,
          subNav: [
            { title: 'Industries', url: '#', isExternal: false, isActive: false },
            { title: 'Solutions', url: '#', isExternal: false, isActive: false },
            { title: 'Services', url: '#', isExternal: false, isActive: false },
            { title: 'Case Studies', url: '#', isExternal: false, isActive: false }
          ]
        },
        {
          title: 'Updates',
          url: '#',
          isExternal: false,
          isActive: false,
          subNav: [
            { title: 'Lorem', url: '#', isExternal: false, isActive: false },
            { title: 'Ipsum', url: '#', isExternal: false, isActive: false },
            { title: 'Dolor', url: '#', isExternal: false, isActive: false }
          ]
        },
        { title: 'About', url: '#', isExternal: false, isActive: false },
        { title: 'Contact', url: '#', isExternal: false, isActive: false },
        {
          title: 'Products',
          url: '#',
          isExternal: false,
          isActive: isProductActive ? true : false,
          subNav: [
            { title: 'Product 1', url: '#', isExternal: false, isActive: false },
            { title: 'Product 2', url: '#', isExternal: false, isActive: isProductActive ? true : false },
            { title: 'Product 3', url: '#', isExternal: false, isActive: false }
          ]
        }
      ]}
      isDesktop={breakpointSiteheader(breakpoint)}
    />
  )
}
